import { select } from 'redux-saga/effects';
import ReactGA from 'react-ga';
import { selectTrackAnalytics } from '../../state/configs/configsSlice';

// eslint-disable-next-line import/prefer-default-export
export function* initializeReactGA() {
  const PORTAL_TRACK_ANALYTICS = yield select(selectTrackAnalytics);

  console.debug(PORTAL_TRACK_ANALYTICS);
  if (PORTAL_TRACK_ANALYTICS) {
    console.debug('initializing react agent');
    ReactGA.initialize('UA-97865765-2');
    ReactGA.pageview('/analytics');

    setInterval(() => {
      ReactGA.event({
        category: 'Session',
        action: 'Keep-Alive',
      });
    }, 120000);
  }
}
